import axios from "axios";


const namespaced = true
const BaseUrl = process.env.VUE_APP_BASE_URL;

const state = {
    statusName:[
      {
        name: "Закрыт",
        value: "close"
      },
      {
        name: "Открыт",
        value: "open"
      },
      {
        name: "В обработке",
        value: "processing"
      }
    ],
    regions: [
      {
        id: 1, name: "Region 1" 
      },
      { 
        id: 2, name: "Region 2" 
      },
      
    ],
    routes: [
        {
            id: 1,
            departure_city: "Route 1",
            destination_city: "Region 20",
            description: "Description 55",
            departure_region: "Region 111",
            destination_region: "Region 222",
            bid: 100000,
            bid_tax: 200000,
            status: "close",
        },
        {
            id: 2,
            departure_city: "Route 12",
            destination_city: "Region 15",
            departure_region: "region 333",
            destination_region: "region 222",
            bid: 120000,
            bid_tax: 180000,
            status: "open",
        },
        {
          id: 3,
          departure_city: "Route 32",
          destination_city: "Region 45",
          departure_region: "region 633",
          destination_region: "region 922",
          bid: 220000,
          bid_tax: 300000,
          status: "processing",
        },
        {
          id: 4,
          departure_city: "Route 32",
          destination_city: "Region 45",
          departure_region: "region 633",
          destination_region: "region 922",
          bid: 220000,
          bid_tax: 300000,
          status: null,
        } 
        
    ],
    filteredRoutes: [],
    loading: false,
    error: null,
}

state.filteredRoutes = [...state.routes];


const getters = {
    allRoutes: (state) => state.routes,
    filteredRoutes: (state) => state.filteredRoutes,
    allRegions: (state) => state.regions,
    isLoading: (state) => state.loading,
    error: (state) => state.error,
}

const  mutations = {
    SET_REGIONS(state, regions) {
      state.regions = regions;
    },
    SET_ROUTES(state, routes) {
      state.routes = routes;
      state.filteredRoutes = routes;
    },
    SET_FILTERED_ROUTES(state, filteredRoutes) {
      state.filteredRoutes = filteredRoutes;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
}

const actions = {
    async fetchRegions({ commit }) {
      commit("SET_LOADING", true);
      try {
        const token = localStorage.getItem("user.access_token");
        const response = await axios.get(BaseUrl+"/ati/regions", {
          headers: { Authorization: `Bearer ${token}` },
        });
        commit("SET_REGIONS", response.data);
      } catch (error) {
        commit("SET_ERROR", error.response?.data || "Failed to fetch regions");
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async fetchRoutes({ commit }) {
      commit("SET_LOADING", true);
      try {
        const token = localStorage.getItem("user.access_token");
        const response = await axios.get(BaseUrl+"/ati/routes", {
          headers: { Authorization: `Bearer ${token}` },
        });
        commit("SET_ROUTES", response.data);
      } catch (error) {
        commit("SET_ERROR", error.response?.data || "Failed to fetch routes");
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async createRoute({ dispatch }, payload) {
      const token = localStorage.getItem("user.access_token");
      try {
        await axios.post(BaseUrl+"/ati/routes", payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        dispatch("fetchRoutes"); // Refresh routes after creation
      } catch (error) {
        throw new Error(error.response?.data || "Failed to create route");
      }
    },
    async updateRoute({ dispatch }, { routeId, route }) {
      const token = localStorage.getItem("user.access_token");
      try {
        await axios.put(BaseUrl+`/ati/routes/${routeId}`, route, {
          headers: { Authorization: `Bearer ${token}` },
        });
        dispatch("fetchRoutes"); // Refresh routes after update
      } catch (error) {
        throw new Error(error.response?.data || "Failed to update route");
      }
    },
    async deleteRoute({ dispatch }, routeId) {
      const token = localStorage.getItem("user.access_token");
      try {
        await axios.delete(BaseUrl+`/ati/routes/${routeId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        dispatch("fetchRoutes"); // Refresh routes after deletion
      } catch (error) {
        throw new Error(error.response?.data || "Failed to delete route");
      }
    },
    async updateRouteStatus({ dispatch }, payload) {
      const token = localStorage.getItem("user.access_token");
      try {
        await axios.patch(BaseUrl+"/ati/routes/status", payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        dispatch("fetchRoutes"); // Refresh routes after status update
      } catch (error) {
        throw new Error(error.response?.data || "Failed to update status");
      }
    },
    filterRoutes({ commit, state }, { searchQuery, status }) {
      let filtered = state.routes;

      // Проверка и преобразование searchQuery в строку
      const query = typeof searchQuery === "string" ? searchQuery.toLowerCase().trim() : "";
    
      if (query) {
        filtered = filtered.filter((route) => {
          const routeString = `${route.departure_city.toLowerCase()}-${route.destination_city.toLowerCase()}`;
          return routeString.includes(query);
        });
      }
    
      if (status) {
        filtered = filtered.filter((route) => route.status === status);
      }
    
      commit("SET_FILTERED_ROUTES", filtered);
    },
}



export default {
    state,
    mutations,
    getters,
    actions,
    namespaced
};